// extracted by mini-css-extract-plugin
export default {"container":"clear-chat-button_container__Ceaqm","disabled":"clear-chat-button_disabled__SwzLu"};